<template>
  <div class="table-settings-preset-item">
    <MRadiobutton
      :label-text="presetName"
      :value="active"
      @selected="$emit('selectPreset')"
    />
    <div class="table-settings-preset-item__controls">
      <MIcon
        v-if="canEdit"
        :icon="iconPencil"
        class="table-preset-controls__icon table-preset-controls__edit"
        @click="$emit('edit')"
      />
      <MIcon
        v-if="canDelete"
        :icon="iconTrash"
        class="table-preset-controls__icon table-preset-controls__delete"
        @click="$emit('delete')"
      />
    </div>
  </div>
</template>

<script>
  import MRadiobutton from 'components/Inputs/Basic/MRadiobutton';
  import MIcon from 'components/Design/MIcon';
  import iconPencil from 'assets/icons/pencil.svg';
  import iconTrash from 'assets/icons/trash-can.svg';

  export default {
    name: 'TableSettingsPresetItem',
    components: {MIcon, MRadiobutton},
    props: {
      preset: {
        type: Object,
        required: true
      },
      active: {
        type: Boolean,
        default: false
      },
      canEditPresetPredicate: {
        type: Function,
        default: () => true
      },
      canDeletePresetPredicate: {
        type: Function,
        default: () => true
      }
    },
    data () {
      return {
        iconPencil,
        iconTrash
      };
    },
    computed: {
      presetName () {
        return this.preset.name;
      },
      canEdit () {
        return this.canEditPresetPredicate(this.preset);
      },
      canDelete () {
        return this.canDeletePresetPredicate(this.preset);
      }
    }
  };
</script>

<style>
  .table-settings-preset-item {
    font-size: 12px;

    display: flex;

    align-items: center;

    height: 28px;

    padding-left: 12px;
    padding-right: 14px;
  }

  .table-settings-preset-item:hover {
    background-color: var(--action-background-color);
  }

  .table-settings-preset-item .m-radiobutton {
    overflow: hidden;
    min-width: 0;
  }

  .table-settings-preset-item .m-radiobutton .m-radiobutton__label {
    color: var(--secondary-text-color);
    text-overflow: ellipsis;

    white-space: nowrap;

    overflow: hidden;

    min-width: 0;

    margin-right: 0;
  }

  .table-settings-preset-item .m-radiobutton .m-radiobutton__check {
    flex-grow: 0;
    flex-shrink: 0;
  }

  .table-settings-preset-item__controls {
    display: none;
    margin-left: auto;
  }

  .table-settings-preset-item:hover .table-settings-preset-item__controls {
    display: flex;
  }

  .table-preset-controls__icon {
    color: var(--gray-text-color);

    cursor: pointer;

    flex-shrink: 0;

    width: 14px;
    height: 14px;

    margin-left: 4px;
  }

  .table-preset-controls__edit:hover {
    color: var(--action-hover-color);
  }

  .table-preset-controls__delete:hover {
    color: var(--error-hover-color);
  }

</style>
